import React from 'react';
import { graphql, useStaticQuery, Link as GatsbyLink } from 'gatsby';
import {
    Box,
    Link,
    Flex,
} from '@chakra-ui/react';
import styled from '@emotion/styled';
import TrecLogo from '../../Footer/Logos/TrecLogo';
import ChamberLogo from '../../Footer/Logos/ChamberLogo';
import TetonGeoCenterLogo from '../../Footer/Logos/TetonGeoCenterLogo';

const NavItem = styled(Box)`
    color: white;
    font-size: 1.25rem;
    text-transform: uppercase;
    font-weight: 800;
    padding-left: ${props => props.pl ? props.pl : '8'};
    padding-right: ${props => props.pr ? props.pr : '8'};
    > a:hover {
        color: #F3CB2A;
        text-decoration: none;
    }

    > a.active {
        color: #F3CB2A;
        text-decoration: none;
    }
    
`

const SubNavbar = (props) => {
    
  return (
    <>
    {props.pageLocation?.includes('/discover') ? (
        <Flex w="100%" 
        bg="blue.600"
        p="4"
        justifyContent="space-between"
        display={{base: 'none', lg: 'flex'}}
        height="100px"
        alignItems="center"
        as="nav"
        h="3rem"
    >
        <Box w="100%">
            <Flex
            justifyContent="flex-start"
            px="4"
            >
            <NavItem  pl={{base: 1, md: 4}} pr={{base: 1, md: 8}}>
                <Link as={GatsbyLink} to="/discover/history" activeClassName="active" variant="sub-nav-item" partiallyActive={true}>
                    History
                </Link>
            </NavItem>
            <NavItem  pl={{base: 1, md: 4}} pr={{base: 1, md: 8}}>
                <Link as={GatsbyLink} to="/discover/victor" activeClassName="active" variant="sub-nav-item" partiallyActive={true}>
                    Victor
                </Link>
            </NavItem>
            <NavItem  pl={{base: 1, md: 4}} pr={{base: 1, md: 8}}>
                <Link as={GatsbyLink} to="/discover/driggs" activeClassName="active" variant="sub-nav-item" partiallyActive={true}>
                    Driggs
                </Link>
            </NavItem>
            <NavItem  pl={{base: 1, md: 4}} pr={{base: 1, md: 8}}>
                <Link as={GatsbyLink} to="/discover/tetonia" activeClassName="active" variant="sub-nav-item" partiallyActive={true}>
                    Tetonia
                </Link>
            </NavItem>
            <NavItem  pl={{base: 1, md: 4}} pr={{base: 1, md: 8}}>
                <Link as={GatsbyLink} to="/discover/maps-travel-info" activeClassName="active" variant="sub-nav-item" partiallyActive={true}>
                    Maps &amp; Travel Info
                </Link>
            </NavItem>
            <NavItem  pl={{base: 1, md: 4}} pr={{base: 1, md: 8}}>
                <Link as={GatsbyLink} to="/discover/winter" activeClassName="active" variant="sub-nav-item" partiallyActive={true}>
                    Winter
                </Link>
            </NavItem>
            <NavItem  pl={{base: 1, md: 4}} pr={{base: 1, md: 8}}>
                <Link as={GatsbyLink} to="/discover/spring" activeClassName="active" variant="sub-nav-item" partiallyActive={true}>
                    Spring
                </Link>
            </NavItem>
            <NavItem  pl={{base: 1, md: 4}} pr={{base: 1, md: 8}}>
                <Link as={GatsbyLink} to="/discover/summer" activeClassName="active" variant="sub-nav-item" partiallyActive={true}>
                    Summer
                </Link>
            </NavItem>
            <NavItem  pl={{base: 1, md: 4}} pr={{base: 1, md: 8}}>
                <Link as={GatsbyLink} to="/discover/fall" activeClassName="active" variant="sub-nav-item" partiallyActive={true}>
                    Fall
                </Link>
            </NavItem>
            </Flex>
        </Box>
    </Flex>
    ) : 
    props.pageLocation?.includes('/trec') ? 
    (<Flex w="100%" 
        bg="blue.600"
        p="4"
        justifyContent="space-between"
        display={{base: 'none', lg: 'flex'}}
        height="100px"
        alignItems="center"
        as="nav"
        h="3rem"
    >
    <Box w="100%">
        <Flex
        justifyContent="flex-end"
        px="4"
        >
       
        <NavItem  pl={{base: 1, md: 4}} pr={{base: 1, md: 8}}>
            <Link as={GatsbyLink} to="/trec/trec-staff-board" activeClassName="active" variant="sub-nav-item" partiallyActive={true}>
                Staff &amp; Board
            </Link>
        </NavItem>
        <NavItem  pl={{base: 1, md: 4}} pr={{base: 1, md: 8}}>
            <Link as={GatsbyLink} to="/trec/business-resources" activeClassName="active" variant="sub-nav-item" partiallyActive={true}>
                Business Resources
            </Link>
        </NavItem>
        <NavItem  pl={{base: 1, md: 4}} pr={{base: 1, md: 8}}>
            <Link as={GatsbyLink} to="/trec/business-involvement" activeClassName="active" variant="sub-nav-item" partiallyActive={true}>
                Business Involvement
            </Link>
        </NavItem>
        </Flex>
    </Box>
</Flex>)
: props.pageLocation?.includes('/chamber-of-commerce') ? 
(<Flex w="100%" 
bg="blue.600"
p="4"
justifyContent="space-between"
display={{base: 'none', lg: 'flex'}}
height="100px"
alignItems="center"
as="nav"
h="3rem"
>
<Box w="100%">
    <Flex
    justifyContent="flex-end"
    px="4"
    >
    <NavItem  pl={{base: 1, md: 4}} pr={{base: 1, md: 8}}>
        <Link as={GatsbyLink} to="/chamber-of-commerce/events" activeClassName="active" variant="sub-nav-item" partiallyActive={true}>
            Chamber Events
        </Link>
    </NavItem>
    <NavItem  pl={{base: 1, md: 4}} pr={{base: 1, md: 8}}>
        <Link as={GatsbyLink} to="/chamber-of-commerce/job-employee-resources" activeClassName="active" variant="sub-nav-item" partiallyActive={true}>
            Job Resources
        </Link>
    </NavItem>
    {/* <NavItem  pl={{base: 1, md: 4}} pr={{base: 1, md: 8}}>
        <Link as={GatsbyLink} to="/chamber-of-commerce/join" activeClassName="active" variant="sub-nav-item" partiallyActive={true}>
            Join The Chamber
        </Link>
    </NavItem> */}
    {/* <NavItem  pl={{base: 1, md: 4}} pr={{base: 1, md: 8}}>
        <Link as={GatsbyLink} to="/chamber-of-commerce/current-members" activeClassName="active" variant="sub-nav-item" partiallyActive={true}>
            Current Members
        </Link>
    </NavItem> */}
    </Flex>
</Box>
</Flex>)
: props.pageLocation?.includes('/teton-geo-center') ? 
(<Flex w="100%" 
bg="blue.600"
p="4"
justifyContent="space-between"
display={{base: 'none', lg: 'flex'}}
height="100px"
alignItems="center"
as="nav"
h="3rem"
>
<Box w="100%">
    <Flex
    justifyContent="center"
    px="4"
    >
    <NavItem  pl={{base: 1, md: 4}} pr={{base: 1, md: 8}}>
        <Link as={GatsbyLink} to="/discover/maps-travel-info" activeClassName="active" variant="sub-nav-item" partiallyActive={true}>
            Maps &amp; Travel Info
        </Link>
    </NavItem>
    </Flex>
</Box>
</Flex>) : null }
        
        </>
    )
}

export default SubNavbar;